import { render, staticRenderFns } from "./MenuActionOrganization.vue?vue&type=template&id=e5321e4a&scoped=true"
import script from "./MenuActionOrganization.vue?vue&type=script&lang=js"
export * from "./MenuActionOrganization.vue?vue&type=script&lang=js"
import style0 from "./MenuActionOrganization.vue?vue&type=style&index=0&id=e5321e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5321e4a",
  null
  
)

export default component.exports